export type RequirementTerminationReason = 'SupplierChange' | 'CustomerChange' | 'Dismantling' | 'Withdrawal' | 'Other';

export const RequirementTerminationReason = {
    SupplierChange: 'SupplierChange' as RequirementTerminationReason,
    CustomerChange: 'CustomerChange' as RequirementTerminationReason,
    Dismantling: 'Dismantling' as RequirementTerminationReason,
    Withdrawal: 'Withdrawal' as RequirementTerminationReason,
    Other: 'Other' as RequirementTerminationReason
};
